export const keyworkTranslation = {
  AM: {
    english: "AM",
    simplified_chinese: "上午",
    traditional_chinese: "上午",
  },
  PM: {
    english: "PM",
    simplified_chinese: "下午",
    traditional_chinese: "下午",
  },
  Deck: {
    english: "Deck",
    simplified_chinese: "甲板",
    traditional_chinese: "甲板",
  },
  AFT: {
    english: "AFT",
    simplified_chinese: "船尾",
    traditional_chinese: "船尾",
  },
  FWD: {
    english: "FWD",
    simplified_chinese: "船头",
    traditional_chinese: "船頭",
  },
  MID: {
    english: "MID",
    simplified_chinese: "船中",
    traditional_chinese: "船中",
  },
  PS: {
    english: " Port & Starboard",
    simplified_chinese: "左舷及右舷",
    traditional_chinese: "左舷及右舷",
  },
  PORT: {
    english: "Port",
    simplified_chinese: "左舷",
    traditional_chinese: "左舷",
  },
  STARBOARD: {
    english: "Starboard",
    simplified_chinese: "右舷",
    traditional_chinese: "右舷",
  },
  HighSea: {
    english: "High Seas",
    simplified_chinese: "海上巡遊",
    traditional_chinese: "海上巡游",
  },
};

export const languages = [
  {
    keySuffix: "EN",
    labelSuffix: "English",
    deck: "Deck",
  },
  {
    keySuffix: "SC",
    labelSuffix: "Simplified Chinese",
    deck: "甲板",
  },
  {
    keySuffix: "TC",
    labelSuffix: "Traditional Chinese",
    deck: "甲板",
  },
];

export const locationLabels = {
  EN: { NA: "NA", FWD: "FWD", MID: "MID", AFT: "AFT" },
  TC: { NA: "NA", FWD: "船頭", MID: "船中", AFT: "船尾" },
  SC: { NA: "NA", FWD: "船头", MID: "船中", AFT: "船尾" },
};

export const sideLabels = {
  EN: {
    NA: "NA",
    "Port & Starboard": "Port & Starboard",
    Port: "Port",
    Starboard: "Starboard",
  },
  TC: {
    NA: "NA",
    "Port & Starboard": "左舷及右舷",
    Port: "左舷",
    Starboard: "右舷",
  },
  SC: {
    NA: "NA",
    "Port & Starboard": "左舷及右舷",
    Port: "左舷",
    Starboard: "右舷",
  },
};

export const vesselIdMap = {
  0: "GDR",
  1: "GDR",
  2: "SNA",
  3: "SVO",
};

export const vesselDecks = {
  1: [null, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18, 19], // Genting Dream
  2: [null, 5, 6, 7, 8, 9, 10, 11, 12, 13], // Star Navigator
  3: [null, 5, 6, 7, 8, 9, 10, 11, 12, 14], // Star Voyager
};
